import './CoralPdp5eModel.scss'

import { Markdown } from '@websrc/App/Components/Markdown/Markdown'
import { mapCoralPdp5eModel } from '@websrc/DataMappers/mapCoralPdp5eModel'
import React, { useEffect, useRef, useState } from 'react'

import { ChevronArrowIcon } from '../../../coral-library/icons/ChevronArrow.icon'

interface CoralPdp5eModelProps {
  model_5e: ReturnType<typeof mapCoralPdp5eModel>
}

export const CoralPdp5eModel: React.FC<CoralPdp5eModelProps> = ({ model_5e }) => {
  const { header, description, e_items } = model_5e
  const [openIndexes, setOpenIndexes] = useState<number[]>([])
  const itemRefs = useRef<(HTMLDivElement | null)[]>([]) // Ref to store item containers

  // Handle item click and toggle open state
  const handleItemClick = (index: number) => {
    setOpenIndexes((prev) =>
      prev.includes(index) ? prev.filter((i) => i !== index) : [...prev, index]
    )
  }

  // Set the dynamic height for the markdown content based on the item height
  useEffect(() => {
    itemRefs.current.forEach((ref, index) => {
      if (ref) {
        const markdownContainer = ref.querySelector(
          '.model-5e__item-markdown-container'
        ) as HTMLElement
        if (markdownContainer) {
          if (openIndexes.includes(index)) {
            markdownContainer.style.height = `${markdownContainer.scrollHeight}px` // Set height to content height
          } else {
            markdownContainer.style.height = '0' // Collapse
          }
        }
      }
    })
  }, [openIndexes]) // Run when openIndexes changes

  return (
    <div className={'model-5e'}>
      <div className={'model-5e__top-content'}>
        <div className={'model-5e__header'}>{header}</div>
        <Markdown className={'model-5e__description'} markdown={description ? description : ''} />
      </div>
      <div className={'model-5e__items'}>
        {e_items.map((item, index) => {
          const isOpen = openIndexes.includes(index)
          return (
            <div
              className={'model-5e__item-container'}
              key={index}
              onClick={() => handleItemClick(index)}
              ref={(el) => (itemRefs.current[index] = el)}
            >
              <div className={'model-5e__dropdown-section'}>
                <div className={'model-5e__dropdown-header'}>{item.header}</div>
                <div className={'model-5e__chevronarrow-icon-container'}>
                  <ChevronArrowIcon
                    className={'model-5e__item-icon'}
                    direction={isOpen ? 'up' : 'down'}
                  />
                </div>
              </div>
              <div className={`model-5e__item-markdown-container ${isOpen ? 'open' : ''}`}>
                <Markdown
                  className={'model-5e__item-markdown'}
                  color={'#636363'} //$global-gray-1000
                  markdown={item.description ? item.description : ''}
                  skipWidth={true}
                />
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
